<div class="pb-4">
  <form
    class="fs-7 d-flex flex-wrap gap-2"
    [formGroup]="filtersForm"
  >
    <base-filter-dropdown
      [items]="locations"
      filterName="location.singular"
      formControlName="location"
    ></base-filter-dropdown>
  </form>
  <hr *ngIf="activeFilters.length > 0" />
  <div class="fs-7 d-flex align-items-center flex-wrap gap-2">
    <div
      *ngFor="let filter of activeFilters"
      class="px-2_5 rounded-pill bg-secondary py-2 active-filter fw-semibold"
    >
      <span class="pe-1 fw-normal">
        {{ filter.filter === 'search' ? ('search.nominative' | translate) : (labels[filter.filter] | translate) }}:
      </span>
      <span>
        {{ (filter.name | translate) || (filter.value | baseFormatDate) }}
      </span>
      <i
        class="fa-solid fa-xmark ms-2 pointer"
        (click)="removeFilter(filter)"
      ></i>
    </div>
    <span
      class="pointer"
      (click)="clearFilters()"
      *ngIf="activeFilters.length"
    >
      {{ 'filter.reset' | translate }}
    </span>
  </div>
</div>

<div class="row d-flex flex-row justify-content-between mt-5">
  <div class="col pb-4 pb-md-0">
    <base-search
      class="d-block mw-100 max-w-md-500px"
      placeholder="providers.search"
      [value]="activatedRoute.snapshot.queryParams.search"
      [useEnterEvent]="true"
      (query)="onSearchChange($event)"
    ></base-search>
  </div>
</div>
